import React from 'react';
import {Redirect} from 'react-router';
import {NavLink} from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import ImageUpload from "components/CustomUpload/ImageUploadForUpdate.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyPhoneNumber,
    verifyNumber,
    verifyAlphaNum,
    verifyName,
    isClinicMasterOrClinic,
    getClinicUserId,
    clinicmaster_id, dashboardRouter
} from '../../../util/globalHelper';

import api from "../../../api/Api";
import TextField from '@material-ui/core/TextField';

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Loader from "../../Loader";

import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registerEmail: "",
            registerEmailState: "",
            imageurl: "",
            allergies: [],
            diseases: [],
            description: {},
            decriptionState: "",
            price: "",
            priceState: "",
            discountedPrice: "",
            discountedPriceState: "",
            BMI: "",
            BMIState: "",
            medication: [],
            alert: null,
            open: true,
            redirect: false,
            titleState: "",
            title: "",
            clinicmaster_id: "",
            clinic_id: "",
            data: null,
            clinicDetail: null,
            serviceList: null,
            clinicsData: null,
            services: [],
            servicesState: [],
            firstService: "",
            contentState: {}
        };
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.CreateAlertonADD = this.CreateAlertonADD.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleChangeServices = this.handleChangeServices.bind(this);
        this.changeServices = this.changeServices.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }

    addServices() {
        let a = [""];
        let b = this.state.services.concat(a);
        this.setState({services: b})
    }

    handleChangeServices(e, index) {
        this.state.services[index] = JSON.parse(e.target.value);
        this.setState({services: this.state.services})
    }

    changeServices(event, index) {
        let a = this.state.services.slice(); //creates the clone of the state
        a[index + 1] = JSON.parse(event.target.value);
        this.state.services[index + 1] = JSON.parse(event.target.value);
        this.setState({services: this.state.services});
    }

    change1stServices(event) {
        this.setState({firstService: JSON.parse(event.target.value)})
        let a = this.state.services.slice(); //creates the clone of the state
        a[0] = JSON.parse(event.target.value);
        this.state.services[0] = JSON.parse(event.target.value);
        this.setState({services: this.state.services});
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
        api.getAllServices().then(json => {
            this.setState({
                serviceList: json.data.data.map(item => {
                    return {
                        "id": item.id ? item.id : item.service_id,
                        "name": item.name ? item.name : item.service_text
                    }
                })
            })
        });
    }


    CreateAlertonADD(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }


    handleImageUrl(url) {
        this.setState({imageurl: url});
    }


    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }


    CallCreateApi(data) {
        api.updatePackages(data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Package Updated Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/packages/all`))
                }
            }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    typeClick() {
        if (this.state.title === "") {
            this.setState({titleState: "error"});
        }
        if (this.state.clinicmaster_id !== "") {
            this.setState({titleState: "error"});
        }
        if (this.state.clinic_id !== "") {
            this.setState({titleState: "error"});
        }
        if (this.state.titleState === "success" &&
            this.state.decriptionState === "success" &&
            this.state.priceState !== "error") {
            var data = {
                "_id": this.props.id.match.params.id, "updated_object": {
                    "active": true, title: this.state.title,
                    description: draftToHtml(convertToRaw(this.state.description.getCurrentContent())),
                    total: this.state.price,
                    discounted_price: this.state.discountedPrice,
                    services: this.state.services.map(item => {
                        return {
                            "id": item.id ? item.id : item.service_id,
                            "name": item.name ? item.name : item.service_text
                        }
                    }),
                    clinic_id: this.state.clinic_id,
                    clinic_master_id: this.state.clinicmaster_id,
                    image: this.state.imageurl
                }
            };
            this.CallCreateApi(data);
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    onEditorStateChange(description) {
        this.setState({
            description,
        });
    };


    render() {
        const {classes} = this.props;
        const {data, clinicsData, description} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0] !== null && (this.state.clinicsData === [null] || this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id))) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.data && this.state.serviceList)
            return (
                <div>
                    {}
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <form>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                labelText="Title"
                                                id="title"
                                                success={this.state.titleState === "success"}
                                                error={this.state.titleState === "error"}
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "title", "novalidation", "required"),
                                                    value: this.state.title
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div style={{minHeight: '100px'}}>
                                                <Editor
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    defaultEditorState={description}
                                                    onEditorStateChange={this.onEditorStateChange}
                                                />
                                            </div>
                                            {/*<TextField*/}
                                            {/*id="standard-multiline-flexible"*/}
                                            {/*label="Description"*/}
                                            {/*multiline*/}
                                            {/*rowsMax="4"*/}
                                            {/*value={this.state.decription}*/}
                                            {/*onChange={e => this.change(e, "decription", "novalidation", "optional")}*/}
                                            {/*className={classes.textField}*/}
                                            {/*margin="normal"*/}
                                            {/*/>*/}
                                            {/*<CustomInput*/}
                                            {/*success={this.state.decriptionState === "success"}*/}
                                            {/*error={this.state.decriptionState === "error"}*/}
                                            {/*labelText="Description "*/}
                                            {/*id="decription"*/}
                                            {/*formControlProps={{*/}
                                            {/*fullWidth: true*/}
                                            {/*}}*/}
                                            {/*inputProps={{*/}
                                            {/*onChange: event =>*/}
                                            {/*this.change(event, "decription", "novalidation", "optional"),*/}
                                            {/*value: this.state.decription*/}

                                            {/*}}*/}
                                            {/*/>*/}
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                labelText="Price"
                                                success={this.state.priceState === "success"}
                                                error={this.state.priceState === "error"}
                                                id="price"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "price", "number", "required"),
                                                    type: "number",
                                                    value: this.state.price

                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                labelText="Discounted Price"
                                                success={this.state.discountedPriceState === "success"}
                                                error={this.state.discountedPriceState === "error"}
                                                id="discountedPrice"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "discountedPrice", "number", "required"),
                                                    type: "number",
                                                    value: this.state.discountedPrice
                                                }}
                                            />
                                        </GridItem>
                                        {isClinicMasterOrClinic() === "" ? <GridItem xs={12} sm={12} md={12}>
                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                    htmlFor="clinicmaster_id"
                                                    className={classes.selectLabel}>
                                                    Clinic Master
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={this.state.clinicmaster_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinicmaster_id",
                                                        id: "clinicmaster_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                        classes={{
                                                            root: classes.selectMenuItem
                                                        }}>
                                                        Select Clinic
                                                    </MenuItem>
                                                    {data.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         style={{height: "1.8em"}}
                                                                         value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </GridItem> : null}
                                        {(isClinicMasterOrClinic() === "" || isClinicMasterOrClinic()) && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="clinic_id"
                                                        className={classes.selectLabel}>
                                                        Clinic
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.clinic_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinic_id",
                                                            id: "clinic_id"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicsData.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             style={{height: "1.8em"}}
                                                                             value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </GridItem> : null}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}
                                                style={{padding: '10px 0'}}>
                                                <InputLabel
                                                    htmlFor="service"
                                                    className={classes.selectLabel}>
                                                    Select Service
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={JSON.stringify(this.state.firstService)}
                                                    onChange={e => this.change1stServices(e)}
                                                    inputProps={{
                                                        name: "firstService",
                                                        id: "firstService"
                                                    }}
                                                > <MenuItem
                                                    disabled
                                                    classes={{
                                                        root: classes.selectMenuItem
                                                    }}>
                                                    Select Service </MenuItem>
                                                    {this.state.clinicDetail !== null && this.state.clinicDetail.clinic_services ? this.state.clinicDetail.clinic_services.map(item => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         value={JSON.stringify(item)}>
                                                            {item.service}  </MenuItem>
                                                    }) : this.state.serviceList.map(item => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         value={JSON.stringify(item)}>
                                                            {item.name}  </MenuItem>
                                                    })}
                                                </Select></FormControl><br/> </GridItem>
                                        {(this.state.services.length === 1 ? this.state.services.slice().splice() : this.state.services.slice().splice(1)).map((number, index) => {
                                            return <GridItem xs={12} sm={12} md={12} key={Math.random()}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                    style={{padding: '10px 0'}}>
                                                    <InputLabel
                                                        htmlFor="service"
                                                        className={classes.selectLabel}>
                                                        Select Service
                                                    </InputLabel><Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={JSON.stringify(number)}
                                                    onChange={e => this.changeServices(e, index)}
                                                    inputProps={{
                                                        name: "service",
                                                        id: "service"
                                                    }}
                                                > <MenuItem
                                                    disabled
                                                    classes={{
                                                        root: classes.selectMenuItem
                                                    }}>
                                                    Select
                                                    Service </MenuItem>{this.state.clinicDetail !== null && this.state.clinicDetail.clinic_services ? this.state.clinicDetail.clinic_services.map(item => {
                                                    return <MenuItem key={Math.random()}
                                                                     classes={{root: classes.selectMenuItem}}
                                                                     value={JSON.stringify(item)}>
                                                        {item.service}  </MenuItem>
                                                }) : this.state.serviceList.map(item => {
                                                    return <MenuItem key={Math.random()}
                                                                     classes={{root: classes.selectMenuItem}}
                                                                     value={JSON.stringify(item)}>
                                                        {item.name}  </MenuItem>
                                                })}
                                                </Select></FormControl><br/> </GridItem>

                                        })}
                                        <GridItem xs={12} sm={7} md={5}>

                                            <Button block size="lg" color="warning"
                                                    onClick={(e) => this.addServices(e)}>Add Service
                                            </Button>
                                        </GridItem>
                                        <GridContainer style={{marginTop: '30px'}}>
                                            <GridItem xs={12} sm={6} md={8}>
                                                <ImageUpload
                                                    addButtonProps={{
                                                        color: "info",
                                                        round: true
                                                    }}
                                                    changeButtonProps={{
                                                        color: "info",
                                                        round: true
                                                    }}
                                                    removeButtonProps={{
                                                        color: "danger",
                                                        round: true
                                                    }}
                                                    handleImageUrl={this.handleImageUrl.bind(this)}
                                                    imageurl={this.state.imageurl}
                                                    role="Package"
                                                />
                                            </GridItem>
                                        </GridContainer>


                                    </GridItem>
                                </GridContainer>
                            </form>

                            <CardFooter className={classes.justifyContentCenter}>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={3} md={2}>
                                        <Button block size="lg" color="warning" onClick={this.typeClick}>
                                            Update
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={3} md={2}>
                                        <NavLink to={dashboardRouter("/packages/all")}>
                                            <Button block size="lg" color="grey">
                                                Cancel
                                            </Button>
                                        </NavLink>
                                        <br/>
                                    </GridItem>
                                </GridContainer>
                            </CardFooter>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    CallReadApi = (id) => {
        api.getPackages({
            _id: id
        }).then(json => {
            this.setState({packageDetail: json.data.data}, () => {
                this.setState({
                    // decription: this.state.packageDetail.decription,
                    description: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(this.state.packageDetail.description)).contentBlocks)),
                    decriptionState: "success",
                    price: this.state.packageDetail.total,
                    priceState: "success",
                    discountedPrice: this.state.packageDetail.discounted_price,
                    discountedPriceState: "success", titleState: "success",
                    title: this.state.packageDetail.title,
                    clinicmaster_id: this.state.packageDetail.clinic_id.clinic_master_id,
                    clinic_id: this.state.packageDetail.clinic_id._id,
                    services: this.state.packageDetail.services.filter(function (value, index, arr) {
                        return value !== "" && value !== null
                    }),
                    imageurl: this.state.packageDetail.image,
                    servicesState: [],
                    firstService: this.state.packageDetail.services[0],
                    active: this.state.packageDetail.active
                })
            });
        }).catch(error => {
            this.setState({notFound: error})
        });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({data: json.data.data})
        }) : this.setState({data: {}, clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()});
    };

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/PackageForm/UpdatePackageForm.jsx